import Hero from './components/Hero';
import WebProduction from './components/WebProduction';
import BrandingBanner from './components/BrandingBanner';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="bg-[#121212] min-h-screen">
      <Hero />
      <WebProduction />
      <BrandingBanner />
      <Contact />
      <Footer />
    </div>
  );
}
